import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { SociedadesComponent } from './sociedades.component';
import { SociedadesService } from './sociedades.service';
import { SociedadesEditarComponent } from './editar/sociedades-editar.component';

const routes = [
    {
        path     : 'sociedades',
        component: SociedadesComponent
    },
    {
        path     : 'sociedades/editar/:idSociedad',
        component: SociedadesEditarComponent
    },
    {
        path     : 'sociedades/nuevo',
        component: SociedadesEditarComponent
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        SociedadesComponent,
        SociedadesEditarComponent,
    ],
    providers: [SociedadesService]
})

export class SociedadesModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/sociedades/sociedades.module.ts